import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

const DEG_TO_RAD = Math.PI / 180;
// Cuánto empujamos la etiqueta hacia afuera, más allá del vértice (en px).
const LABEL_OUTWARD_OFFSET = 16;

// Dot personalizado: dibuja el punto y coloca el valor numérico SIEMPRE por
// fuera del contorno de la figura. Como el vértice es el punto más lejano del
// polígono sobre su propio eje, empujar la etiqueta radialmente hacia afuera
// (mismo ángulo, mayor radio) garantiza que nunca se sobreponga a la figura.
// recharts v3 expone en cada dot: cx/cy = vértice, y points[index] = el punto
// completo con el centro (cx,cy), ángulo y radio.
const ValueDot = (props) => {
  const { cx, cy, value, points, index } = props;
  if (cx == null || cy == null || typeof value !== 'number' || Number.isNaN(value)) {
    return null;
  }

  const entry = Array.isArray(points) ? points[index] : null;

  // Fallback: encima del punto si no hay geometría polar disponible.
  let labelX = cx;
  let labelY = cy - 10;

  if (entry && typeof entry.angle === 'number' && entry.cx != null && entry.cy != null) {
    const radian = entry.angle * DEG_TO_RAD;
    const labelRadius = (entry.radius || 0) + LABEL_OUTWARD_OFFSET;
    labelX = entry.cx + Math.cos(radian) * labelRadius;
    labelY = entry.cy - Math.sin(radian) * labelRadius;
  }

  return (
    <g>
      <circle cx={cx} cy={cy} r={3.5} fill="#3b82f6" stroke="#ffffff" strokeWidth={1.5} />
      <text
        x={labelX}
        y={labelY}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={13}
        fontWeight={700}
        fill="#1e3a8a"
        stroke="#ffffff"
        strokeWidth={3}
        paintOrder="stroke"
      >
        {Math.round(value)}
      </text>
    </g>
  );
};

const PlayerRadarChart = ({ stats }) => {
  const data = [
    { attribute: 'Velocidad', value: stats.pace, fullMark: 100 },
    { attribute: 'Disparo', value: stats.shooting, fullMark: 100 },
    { attribute: 'Pase', value: stats.passing, fullMark: 100 },
    { attribute: 'Regate', value: stats.dribbling, fullMark: 100 },
    { attribute: 'Defensa', value: stats.defending, fullMark: 100 },
    { attribute: 'Físico', value: stats.physical, fullMark: 100 },
  ];

  return (
    <div className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} margin={{ top: 24, right: 36, bottom: 24, left: 36 }}>
          <PolarGrid stroke="#e5e7eb" />
          <PolarAngleAxis
            dataKey="attribute"
            tick={{ fontSize: 16, fill: '#6b7280', fontWeight: 500 }}
            tickLine={false}
          />
          {/* Mantenemos la escala fija 0-100 pero ocultamos los ticks rectos. */}
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={false}
            tickLine={false}
            axisLine={false}
          />
          <Radar
            name="Estadísticas"
            dataKey="value"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.3}
            strokeWidth={3}
            dot={<ValueDot />}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PlayerRadarChart;
